<template>
  <div>
    <div class="lds-dual-ring" v-if="loading"></div>
    <div v-if="error" class="error" id="login_error"><AlertCircleOutline/> Could not retrieve order</div>
    <div class="banner" v-if="!loading && !error">
        <div class="bannercontent">
          <div class="left">
            <div class="logo"></div>
            <div class="bannertitle">{{order.orderID}}</div>
            <div class="bannerdesc">{{order.date}}</div>
            <div class="tag" :class="order.status" @click="showStatusDropdown = !showStatusDropdown" style="cursor: pointer; position: relative;">
              {{ this.orderStatus[order.status] }}
              <ChevronDown/>
              <div v-if="showStatusDropdown" class="statusDropdown">
                <div class="statusOption" @click="selectStatus('COMPLETED')">Completed</div>
                <div class="statusOption" @click="selectStatus('CANCELED')">Cancelled</div>
                <div class="statusOption" @click="selectStatus('IN_PROGRESS')">In progress</div>
                <div class="statusOption" @click="selectStatus('OBA_REQUIRED')">OBA Required</div>
              </div>
            </div>
            <button class="moreButton button" @click="getOrderInfo(false)"><ChevronDown/>Load brandconfig</button>
          </div>

          <div class="right">
            <div v-for="item in order.components" :key="item.serial" :class="item.type" v-bind:style="{ 'background-image': 'url('+getModelImg(item.model, item.type)+')', 'opacity' : (item.active ? '1' : '0.5')}">
              <div><div>{{item.type}}</div><br>{{item.serial}}<br>{{item.bdAddr}}</div>
            </div>
          </div>
        </div>
      </div>
      
      <div v-if="showConfirm" class="confirmOverlay">
        <div class="confirmBox">
          <div>Are you sure? overriding the order status can break stuff. Some changes might not be reversible. <br>Please enter the reason for the change below</div>
          <input v-model="statusChangeReason" placeholder="Enter reason for change" required style="width: 100%; margin-top: 10px; padding: 5px; box-sizing: border-box;">
          <div class="confirmButtons">
            <button class="button" @click="confirmStatusChange(false)">Cancel</button>
            <button class="button" @click="confirmStatusChange(true)">Confirm</button>
          </div>
        </div>
      </div>
    
    <div class="content"  v-if="!loading">

      <div v-if="order.brandconfig">
        <div class="title">Customer details</div>
        <b>Name: </b> {{ order.brandconfig.firstname }} {{ order.brandconfig.lastname }} ({{ order.brandconfig.initials }})<br>
        <b>Company: </b> {{ order.brandconfig.companyName }} <br>
        <b>Department: </b> {{ order.brandconfig.department }} <br>
        <br>
      </div>


      <div class="title">Flow details</div>
      <div v-for="(node,index) in order.flow.nodes" :key="node.key" style="display: inline-block;">
        
        <div class="exactList" v-if="combinedExactItems[index].length != 0">
          <div class="exactItem" v-for="exactItem in combinedExactItems[index]" :key="exactItem.exact_id">
            <input class="itemAmount" v-model="exactItem.amount"> {{ exactItem.unit }} -
            {{exactItem.description}}
          </div>
          </div>
        <div class="arrowExact" v-if="combinedExactItems[index].length != 0"><ArrowDownIcon/></div>

        <!-- Optional node -->
        <div v-if="node.isOptional" class="optionalMarker">Optional</div>

        <div class="node" :class="{ active: node.results.length && node.results.some(result => result.testID == node.testID && result.testVersion == node.testVersion) }" v-if="!node.isPrinter">
          <b style="padding: 8px" v-if="node.station">{{ node.station.name }}</b>
          <div v-if="node.hasOwnProperty('testID')" class="nodeItem" :class="{ nodeItemActive: node.results.length && node.results.some(result => result.testID == node.testID && result.testVersion == node.testVersion) }">{{ node.test.name }}</div>
          <div v-if="node.stationID == 'ENGI'" class="nodeItem" :class="{ nodeItemActive: node.results.length }">Engineering</div>
          <button class="button" @click="$router.push('/results?orderid='+order.orderID+'&stationid='+node.stationID)"><OpenInNew/> {{ node.results.length }} testresults</button>
        </div>
        
        <!-- Printer node -->
        <div class="node" :class="{ active: order.printDetails != null }" v-if="node.isPrinter">
          <b style="padding: 8px">3D Printing</b>
          <div class="nodeItem" v-if="order.printDetails != null" :class="{ nodeItemActive: order.printDetails != null }">{{ order.printDetails.printer.name }} ({{ order.printDetails.printer.serial }})</div>
          <div class="nodeItem" v-if="order.printDetails == null">No print info</div>
          <div class="graphBlock" v-if="order.printDetails != null">
          <div class="graphBlockPart" style="background-color: rgb(93, 149, 77)" :style="` width: ${order.printDetails.build.currentPercentage}%`">{{order.printDetails.build.currentPercentage}}%</div>
          </div>
          <div class="graphBlock" v-if="order.printDetails == null">
          <div class="graphBlockPart" :style="`width: 100%`">0%
          </div>
          </div>
        </div>
        
        <div v-if="index != (order.flow.nodes.length-1) && !order.flow.nodes[index+1].hasOwnProperty('isOptional')" class="arrow"><ArrowRight/></div>
        <div v-if="index != (order.flow.nodes.length-1) && order.flow.nodes[index+1].hasOwnProperty('isOptional')" class="optionalArrow">|</div>
      </div>

      <div class="title">Requested components</div>
      <div class="auditLog">
        <div v-for="(item,index) in order.requestedComponents" :key="index" class="auditEntry">
          <div class="componentTag">{{item.model}}</div> <div v-if="item.serialLeft"> Requested serial left: {{item.serialLeft}} </div> <div v-if="item.serialRight">Requested serial right: {{item.serialRight}}</div>
          
        </div>
      </div>
      
      <div class="title">Audit log</div>
      <div class="auditLog">
        <div v-for="(logEntry,index) in order.auditLog" :key="index" class="auditEntry">
          <div class="auditTag">{{logEntry.user}}</div> {{logEntry.info}}
          <div style="font-size: 11px; font-weight: bold;">{{logEntry.date}}</div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import AlertCircleOutline from 'vue-material-design-icons/AlertCircleOutline.vue'
import ArrowRight from 'vue-material-design-icons/ArrowRight.vue'
import OpenInNew from 'vue-material-design-icons/OpenInNew.vue'
import ChevronDown from 'vue-material-design-icons/ChevronDown.vue'
import ArrowDownIcon from 'vue-material-design-icons/ArrowDown.vue'
export default {
  name: 'Order',
  components: {
    AlertCircleOutline,
    ArrowRight,
    OpenInNew,
    ChevronDown,
    ArrowDownIcon
  },
  data() {
    return{
      order: [],
      stations: [],
      loading: true,
      error: false,
      orderStatus:
      {
        "CREATED" : 'Created',
        "SLOT_ASSIGNED" : 'Slot Assigned',
        "SLOT_MISSED" : 'Slot Missed',
        "IN_PROGRESS" : 'In Progress',
        "COMPLETED" : 'Completed',
        "OBA_REQUIRED" : 'OBA Required',
        "CANCELED" : 'Canceled',
        "ONHOLD" : 'On Hold',
        "PRINTING" : 'Printing in progress',
        "PRINTING_COMPLETE" : 'Printing complete',
      },
      combinedExactItems: []
      ,
      // Dropdown / confirm state
      tempStatus: '',
      showConfirm: false,
      newStatus: null,
      showStatusDropdown: false
    }
  },
  mounted() {
     
      this.axios
      .get('/stations')
      .then(response => {
          this.stations = response.data;

          this.getOrderInfo(true);

      })
      .catch(err => {
          console.error(err);
          this.loading = false;
          this.error = true;
      });
  },
  methods: {
    getOrderInfo(skipExact)
    {
      this.loading = true;
      var route = '/order/'+this.$route.params.id
      if(skipExact === true)
      {
        route += '/skip';
      }
      this.axios
          .get(route)
          .then(response => {
              this.order = response.data;
              this.loading = false;
              this.tempStatus = this.order.status;
              
              for(let i = 0; i < this.order.flow.nodes.length; i++)
              {
                for(let x = 0; x < this.stations.length; x++)
                {
                  if (this.order.flow.nodes[i].stationID == this.stations[x].stationID)
                  {
                    this.order.flow.nodes[i].station = this.stations[x];
                    break;
                  }
                }

                this.combinedExactItems[i] = [];

                for(let y = 0; y < this.order.flow.nodes[i].results.length; y++)
                {

                  if(this.order.flow.nodes[i].results[y].exactItems != null)
                  {

                    for(let z = 0; z < this.order.flow.nodes[i].results[y].exactItems.length; z++)
                    {
                        let tmp = this.order.flow.nodes[i].results[y].exactItems[z];
                        let found = false;
          
                        for(let broer = 0; broer < this.combinedExactItems[i].length; broer++)
                        {
                          if(tmp.exact_id == this.combinedExactItems[i][broer].exact_id)
                          {
                            found = true;
                            this.combinedExactItems[i][broer].amount += tmp.amount;
                          }
                        }
                        if(found == false)
                        {
                          this.combinedExactItems[i].push(tmp);
                        }
                    }
                  }
                }
              }
              
              let left = false, right = false, cradle = false
              let shellL = false, shellR = false;
              for(let i = 0; i < this.order.components.length; i++)
              {
                  if (left == false && this.order.components[i].type == "LEFT")
                  {
                    this.order.components[i].active = true;
                    left = true;
                  }
                  if (right == false && this.order.components[i].type == "RIGHT")
                  {
                    this.order.components[i].active = true;
                    right = true;
                  }
                  if (cradle == false && this.order.components[i].type == "CRADLE")
                  {
                    this.order.components[i].active = true;
                    cradle = true;
                  }
                  if (shellL == false && this.order.components[i].type == "SHELL_LEFT")
                  {
                    this.order.components[i].active = true;
                    shellL = true;
                  }
                  if (shellR == false && this.order.components[i].type == "SHELL_RIGHT")
                  {
                    this.order.components[i].active = true;
                    shellR = true;
                  }
              }
              return true;
          })
          .catch(err => {
              console.error(err);
              return false;
          });
    },
    onStatusSelectChange()
    {
      this.newStatus = this.tempStatus;
      this.tempStatus = this.order.status;
      this.showConfirm = true;
    },
    confirmStatusChange(confirm)
    {
      if(confirm && this.newStatus)
      {
        if(!this.statusChangeReason) {
          alert("Please enter a reason for the status change.");
          return;
        }
        this.performStatusChange(this.newStatus, this.statusChangeReason);
      }
      else
      {
        // cancel
        this.newStatus = null;
        this.showConfirm = false;
      }
    },
    performStatusChange(status, reason)
    {
      // Placeholder API call — change to real endpoint as needed
      const route = '/order/setstatus';
      this.axios.post(route, { orderID: this.order.orderID, status: status, reason: reason })
            .then(response => {
          this.showConfirm = false;
          // Check if error key exists in response
          if (response.data.error) {
              if(response.data.error === "ORDER_ALLREADY_COMPLETED") {
                  alert("Cannot change status: Order is already completed or canceled.");
              } else {
              alert("Error changing status: " + response.data.error);
              return;
              }
          }

          this.getOrderInfo(true);

      })
      .catch(err => {
          console.error(err);
          this.loading = false;
          this.error = true;
      });
    },
    getModelImg(url, itemType) 
    {
      if(itemType == "PCB")
      {
        url = "MANGO_PCB";
      }

      try {
        var images = require.context('../assets/models', false, /\.png$/)
        return images('./' + url + ".png")
      }
      catch(error)
      {
        if(url.includes("C_"))
        {
          return images('./unknown_cr.png')
        }
        if(url.includes("E_"))
        {
          return images('./unknown_eb.png')
        }
      }
    },
    selectStatus(status)
    {
      this.newStatus = status;
      this.showStatusDropdown = false;
      this.showConfirm = true;
    }
  }
}
</script>
<style scoped>
.itemAmount{
  display: inline-block;
  background-color: #6d6d6d;
  color: white;
  border-radius: 3px;
  font-weight: bold;
  margin-top: 0px;
  width: 25px;
  height: 6px;
  border-color: transparent;
  padding: 0;
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: center;
}
.exactList{
  width: 200px;
  padding: 5px;
  margin-top: 10px;
  border-radius: 2px;
  margin: 0 auto;
  left: -15px;
  position: relative;
  border-style: dashed;
  border-width: 2px;
  border-color: #4d4d4d;
  margin-top: 10px;
}

.exactItem{
  display: inline-block;
  background-color: white;
  color: #575757;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  padding: 5px;
  margin-bottom: 2px;
}
.arrowExact{
  font-size: 30px;
  text-align: center;
  color: #5e5e5e;
  vertical-align: top;
  left: -15px;
  position: relative;
}
.auditLog{
  background-color: #fcfcfc;
  border-radius: 2px;
  padding: 5px;
  font-size: 11px;
  margin-top: 5px;
}
.auditEntry{
  display: block;
  border-bottom: #ececec;
  border-width: 1px;
  border-bottom-style: solid;
  padding: 4px;
  color: rgb(65, 65, 65);
}

.auditEntry:last-child {
  border-width: 0px;
}

.auditTag{
  border-color: #8571bd;
  border-width: 1px;
  border-style: solid;
  display: inline-block;
  padding: 2px;
  font-weight: bold;
  border-radius: 2px;
}

.componentTag{
  background-color: #9b60cc;
  color: white;
  border-width: 1px;
  border-style: solid;
  display: inline-block;
  padding: 2px;
  font-weight: bold;
  border-radius: 2px;
}

.banner{
  min-height: 160px;
  height: 100%;
}
.content{
  /* text-align: center; */
}
.arrow{
  height: 40px;
  font-size: 30px;
  text-align: center;
  color: #5e5e5e;
  display: inline-block;
  vertical-align: top;
  margin-top: 40px;
}
.optionalArrow{
  height: 40px;
  font-size: 30px;
  text-align: center;
  color: #5e5e5e;
  display: inline-block;
  vertical-align: top;
  margin-top: 40px;
  margin-left: 20px;
  margin-right: 20px;
}
.node{
  background-color: #a6a6a6;
  color: white;
  min-width: 200px;
  height: 100px;
  border-radius: 3px;
  padding-top: 10px;
  display: inline-block;
  text-align: center;
  margin-top: 10px;
  opacity: 0.5;
}

.title
{
  font-weight: bold;
  font-size: 20px;
  color:#444444;
  margin-top: 5px;
}

.graphBlock{
  background-color: #4d4d4d;
  text-align: left;
  width: 100%;
  margin-top: 5px;
  height: 25px;
  white-space: nowrap;
}
.graphBlockPart{
  background-color: white;
  width: 0%;
  height: 25px;
  display: inline-block;
  text-align: center;
  line-height: 25px;
  color: white;
  font-weight: bold;
}

.active{
  background-color: #80bd71;
  opacity: 1;
}

.button{
  margin-top: 5px;
  background-color: transparent;
}
.button:hover{
  background-color: #67995b;
}

.moreButton{
  display: block;
  margin-top: 0px;
  background-color: #919191;
}
.moreButton:hover{
  background-color: #616161;
}

.nodeItem{
  background-color: #868686;
  padding: 5px;
  margin-top: 5px;
}
.nodeItemActive{
  background-color: #67995b;
}
.left{
  float: left;
}
.right{
  float: right;
  display: inline-block;
  padding-top: 25px;
  padding-bottom: 25px;
}

.error{
  width: inherit;
  height: 500px;
  line-height: 500px;
  color: #5e5e5e;
  font-size: 25px;
}
.tag{
  display: inline-block;
  padding: 6px 8px;
  border-radius: 3px;
  color: white;
  font-weight: bold;
  text-align: center;
}
.statusDropdown{
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  z-index: 100;
  min-width: 150px;
  margin-top: 4px;
}
.statusOption{
  padding: 8px 12px;
  color: #333;
  cursor: pointer;
  font-weight: normal;
}
.statusOption:hover{
  background-color: #f0f0f0;
}
.tag select{
  background: transparent;
  border: none;
  color: inherit;
  font-weight: inherit;
  appearance: none;
  -webkit-appearance: none;
  padding: 0;
  margin: 0;
}

.confirmOverlay{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.confirmBox{
  background: #ffffff;
  padding: 16px;
  border-radius: 4px;
  color: #333;
  min-width: 280px;
}
.confirmButtons{
  margin-top: 12px;
  text-align: right;
}
.confirmButtons .button{
  margin-left: 8px;
  background-color: tomato;
}
.CRADLE{
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-position-y: 10px;
  height: 150px;
  width: 200px;
  display: inline-block;
  margin-right: 10px;
  border-radius: 10px;
  border: 1px solid #b8b8b8;
}
.CRADLE div{
  position: absolute;
  width: inherit;
  text-align: center;
  background-color: #9c9c9c;
  color: white;
  border-radius: 2px;
  padding-bottom: 3px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.CRADLE div div{
  background-color: #80bd71;
  padding: 0px;
  border-radius: 2px;
  font-weight: bold;
  font-size: 12px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.LEFT{
  background-repeat: no-repeat;
  background-size: cover;
  height: 150px;
  width: 180px;
  display: inline-block;
  margin-right: 10px;
  background-position-x: -15px;
  background-position-y: 10px;
  border-radius: 10px;
  border: 1px solid #b8b8b8;
}
.RIGHT{
  background-repeat: no-repeat;
  background-size: cover;
  height: 150px;
  width: 180px;
  display: inline-block;
  margin-right: 10px;
  background-position-x: -15px;
  background-position-y: 10px;
  border-radius: 10px;
  border: 1px solid #b8b8b8;
}

.LEFT div{
  position: absolute;
  width: inherit;
  text-align: center;
  background-color: #9c9c9c;
  color: white;
  border-radius: 2px;
  padding-bottom: 3px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.LEFT div div{
  background-color: #5f82ce;
  padding: 0px;
  border-radius: 2px;
  font-weight: bold;
  font-size: 12px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.RIGHT div{
  position: absolute;
  width: inherit;
  text-align: center;
  background-color: #9c9c9c;
  color: white;
  border-radius: 2px;
  padding-bottom: 3px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.RIGHT div div{
  background-color: #ce5f5f;
  padding: 0px;
  border-radius: 2px;
  font-weight: bold;
  font-size: 12px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.SHELL_LEFT{
  background-repeat: no-repeat;
  background-size: cover;
  height: 150px;
  width: 180px;
  display: inline-block;
  margin-right: 10px;
  background-position-x: -15px;
  background-position-y: 10px;
  border-radius: 10px;
  border: 1px solid #b8b8b8;
}
.SHELL_LEFT div{
  position: absolute;
  width: inherit;
  text-align: center;
  background-color: #9c9c9c;
  color: white;
  border-radius: 2px;
  padding-bottom: 3px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.SHELL_LEFT div div{
  background-color: #5f82ce;
  padding: 0px;
  border-radius: 2px;
  font-weight: bold;
  font-size: 12px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}


.SHELL_RIGHT{
  background-repeat: no-repeat;
  background-size: cover;
  height: 150px;
  width: 180px;
  display: inline-block;
  margin-right: 10px;
  background-position-x: -15px;
  background-position-y: 10px;
  border-radius: 10px;
  border: 1px solid #b8b8b8;
}
.SHELL_RIGHT div{
  position: absolute;
  width: inherit;
  text-align: center;
  background-color: #9c9c9c;
  color: white;
  border-radius: 2px;
  padding-bottom: 3px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.SHELL_RIGHT div div{
  background-color: #ce5f5f;
  padding: 0px;
  border-radius: 2px;
  font-weight: bold;
  font-size: 12px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.PCB{
  background-repeat: no-repeat;
  background-size: cover;
  height: 150px;
  width: 180px;
  display: inline-block;
  margin-right: 10px;
  border-radius: 10px;
  border: 1px solid #b8b8b8;

}
.PCB div{
  position: absolute;
  width: inherit;
  text-align: center;
  background-color: #9c9c9c;
  color: white;
  border-radius: 2px;
  padding-bottom: 3px;
}

.PCB div div{
  background-color: #80bd71;
  padding: 0px;
  border-radius: 2px;
  font-weight: bold;
  font-size: 12px;
}

.FAIL{
  background-color: #bd7171;
}

.PASS {
  background-color: #67995b;
}

.BLUE{
  background-image: url('/assets/bamboo_cradle_black.png');
}

.RED{
  background-image: url('/assets/bamboo_cradle_red.png');
}

.BLACK{
  background-image: url('/assets/bamboo_cradle_black.png');
}

.CUSTOM{
  background-image: url('/assets/bamboo_cradle_custom.png');
}

.COMPLETED{
  background-color: #71bd84;
}

.INPROGRESS{
  background-color: #7971bd;
}

.SLOT_ASSIGNED{
  background-color: #df8764;
}

.SLOT_MISSED{
  background-color: #bd7171;
}

.CANCELED{
  background-color: #bd7171;
}

.PRINTING{
  background-color: #13dfbd;
}

.PRINTING_COMPLETE{ 
  background-color: #ecb94b;
}

.OBA_REQUIRED{
  background-color: #d1ce1d;
}
.optionalMarker{
  background-color: #f6a121;
  border-radius: 3px;
  padding: 5px;
  text-align: center;
  color: white;
}

</style>
